import { useIntl } from 'react-intl';
import DialogTitle from '@rossum/components/dialog-title/DialogTitle';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@rossum/ui/material';

type CancelActivityDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const CancelActivityDialog = ({
  open,
  onClose,
  onConfirm,
}: CancelActivityDialogProps) => {
  const intl = useIntl();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          elevation: 0,
          sx: { width: 448 },
        },
      }}
    >
      <DialogTitle
        title={intl.formatMessage({
          id: 'features.activities.cancelActivity.dialogTitle',
        })}
        onClose={onClose}
      />
      <DialogContent>
        <Alert severity="warning" sx={{ mt: 2.5 }}>
          {intl.formatMessage({
            id: 'features.activities.cancelActivity.dialogText',
          })}
        </Alert>
      </DialogContent>
      <DialogActions sx={{ pb: 2, pr: 2 }}>
        <Button
          variant="outlined"
          data-cy="keep-activity-button"
          color="secondary"
          onClick={onClose}
        >
          {intl.formatMessage({
            id: 'features.activities.cancelActivity.keep',
          })}
        </Button>
        <Button
          autoFocus
          variant="contained"
          data-cy="cancel-activity-button"
          onClick={onConfirm}
        >
          {intl.formatMessage({
            id: 'features.activities.cancelActivity.cancel',
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
